import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var AdContext = /*#__PURE__*/React.createContext({
  placement: 'body-top',
  element: null
});

// Persisted for the whole session.
// The state is used to use different ad placements.
if (false) AdContext.displayName = "AdContext";
var randomSession = Math.random();

// Distribution profile:
// 20% body-inline
// 80% body-image
export var adShape = randomSession < 0.2 ? 'inline' : 'image';
export function AdManager(_ref) {
  var _ref$classSelector = _ref.classSelector,
    classSelector = _ref$classSelector === void 0 ? '.description' : _ref$classSelector,
    children = _ref.children;
  var _React$useState = React.useState({
      placement: 'body-top',
      element: null
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    portal = _React$useState2[0],
    setPortal = _React$useState2[1];
  useEnhancedEffect(function () {
    var container = document.querySelector(classSelector);
    setPortal({
      placement: 'body-top',
      element: container
    });
  }, [classSelector]);
  return /*#__PURE__*/_jsx(AdContext.Provider, {
    value: portal,
    children: children
  });
}